<!--mat-card (click)="doClick()">
  <mat-card-header
    *ngIf="showHeader"
    [ngClass]="isAssigned() ? 'assigned' : 'unassigned'"
  >
    <mat-card-title>{{ getStatus() }}</mat-card-title>
    <mat-card-subtitle>{{ getStartDate() }}</mat-card-subtitle>
  </mat-card-header>

  <img id="card-image" mat-card-image [alt]="getAlt()" [src]="getImgSrc()" />
  <mat-card-content>
    <h3 class="">{{ getTitle() }}</h3>
    <p class="">{{ getDescription() }}</p>
  </mat-card-content>

  <mat-card-footer>
    <div>
      <mat-card-title>{{
        'Unit ' + unitNumber.toString() | uppercase
      }}</mat-card-title>
      <mat-card-subtitle>{{ getStatus() | uppercase }}</mat-card-subtitle>
    </div>
  </mat-card-footer>
</mat-card-->

<mat-card
  (click)="isGrades ? null : doClick()"
  [ngClass]="{ 'center-container': !showImageData }"
>
  <img
    id="card-image"
    mat-card-image
    [alt]="getAlt()"
    [src]="getImgSrc()"
    [ngClass]="{ 'center-image': !showImageData }"
  />
  <mat-card-content *ngIf="showImageData">
    <h3 class="unit-title" [matTooltip]="getTitle()">
      {{ getTitle() }}
    </h3>
    <p class="meta-description" [matTooltip]="getDescription()">
      {{ getDescription() }}
    </p>
  </mat-card-content>
  <mat-card-footer
    *ngIf="showImageData && showImageStatus"
    [ngStyle]="getStyles()"
  >
    <mat-card-title>{{
      'Unit ' + unitNumber.toString() | uppercase
    }}</mat-card-title>
    <!-- <mat-card-subtitle>{{ getStatus() | uppercase }}</mat-card-subtitle> -->
  </mat-card-footer>
</mat-card>
